import Collapsable from './Collapsable';
import './Collapsable.scss';

export default Collapsable;